import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { AppTranslateModule } from '@core/app-translate.module';

import { LoadingIndicatorComponent } from './loading-indicator.component';
import { MatDialogModule } from '@angular/material/dialog';

export const imports: NgModule['imports'] = [FlexLayoutModule, MatProgressSpinnerModule];

@NgModule({
  declarations: [LoadingIndicatorComponent],
  imports: [...imports, CommonModule, AppTranslateModule, MatDialogModule],
  exports: [LoadingIndicatorComponent],
})
export class LoadingIndicatorModule {}
